import React, { ReactElement } from 'react';
import Head from 'next/head';
import { Nullable } from '@lerna-core';
import { DiscountProgramFaviconContainerProps } from './discountProgramFavicon.model';
import { getFaviconSrc } from './doscountProgramFavicon.helper';

export const DiscountProgramFaviconContainer = ({
  favicon,
}: DiscountProgramFaviconContainerProps): Nullable<ReactElement> => {
  const faviconImageResource = favicon?.imageResource;
  const faviconImageSrc =
    faviconImageResource && getFaviconSrc(faviconImageResource);

  if (!faviconImageSrc) return null;

  return (
    <Head>
      <link rel="shortcut icon" href={faviconImageSrc} />
    </Head>
  );
};
